export default path => `${process.env.PUBLIC_URL}${path}`;



// WEBPACK FOOTER //
// ./src/helpers/path.js